<div [hidden]="feedbacks.length == 0" class="version-details-feedback">
  <ul>
    <li *ngFor="let feedback of feedbacks">
      <core-version-feedbacks-item
        [feedback]="feedback"
        [user]="user"
        [archiveFeedbackAccess]="archiveFeedbackAccess"
        (archiveAction)="sendAction($event)"
      ></core-version-feedbacks-item>
    </li>
  </ul>
</div >